//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, SUB_KEY } from '../_service/credit'
import page_log from '@/common/mixins/page_log'
import Config from './config'
import QqMap from '@/components/views/map'
let MAP_CTX

const default_marker = {
    iconPath: 'https://cdn.vip-wifi.com/fangchan/img/packageB/credit/marker.png',
    width: 5,
    height: 5,
    zIndex: 0
}
const common_callout = {
    display: 'ALWAYS',
    borderRadius: 45,
    fontSize: 12,
    padding: 12,
    anchorY: -2,
    borderWidth: 1,
    borderColor: '#00AF8C'
}
const default_callout = {
    color: '#35B097',
    bgColor: '#E8FCF2',
    ...common_callout
}

const selected_callout = {
    color: '#FFFFFF',
    bgColor: '#00B08D',
    borderColor: '#00B08D',
    ...common_callout
}

export default {
    components: {
        QqMap
    },
    data () {
        return{
            SUB_KEY,
            city: '',
            longitude: '',
            latitude: '',
            agencies: [],
            markers: [],
            markers_: [],
            selected: 0,
            getLocationSuccess: false,
            url: ''
        }
    },
    mixins: [
        page_log({ page_name: '征信查询服务机构' })
    ],
    computed: {
        scroll_into_view () {
            return `item-${this.selected}`
        },
        points () {
            return this.markers.filter(({ nearby_distance }) => nearby_distance < 3500).map(({ longitude, latitude }) => {
                return {
                    longitude,
                    latitude
                }
            })
        }
    },
    destroyed () {
        MAP_CTX = null
    },
    async mounted () {
        const { url, longitude, latitude } = Config
        this.url = url
        this.getLocationSuccess = false
        this.longitude = longitude
        this.latitude = latitude
        this.getAgencies(`${longitude},${latitude}`)
    },
    methods: {
        getMapCtx () {
            if (MAP_CTX) {
                return MAP_CTX
            }
            MAP_CTX = wx.createMapContext('credit-map')
            return MAP_CTX
        },
        moveCenter (center) {
            const ctx = this.getMapCtx()
            ctx.moveToLocation(center)
            ctx.setCenterOffset({
                offset: [0.5, 0.3]
            })
        },
        moveDefaultCenter (center) {
            const { longitude, latitude } = center
            if (this.getLocationSuccess) {
                this.moveCenter({
                    longitude,
                    latitude
                })
            } else {
                this.longitude = longitude
                this.latitude = latitude
            }
        },
        getAgencies (location) {
            get({
                location
            }).then(res => {
                const { agencies } = res
                this.agencies = agencies.map(item => {
                    const { nearby_distance } = item
                    item.distance = nearby_distance < 1000 ? `${nearby_distance}m` : `${(nearby_distance / 1000).toFixed(2)}km`
                    return item
                })
                this.markers = agencies.map((marker, i) => {
                    const { location, name, nearby_distance, branch } = marker
                    const [longitude, latitude] = location.split(',').map(val => Number(val))
                    const new_name = name.match(/.{1,16}/g).join('\n')
                    const content = branch ? `${new_name}\n（${branch}）` : new_name
                    if (i === 0) {
                        this.moveDefaultCenter({
                            longitude,
                            latitude
                        })
                    }
                    return {
                        id: i,
                        longitude,
                        latitude,
                        ...default_marker,
                        callout: i === 0 ? {
                            content,
                            ...selected_callout
                        } : {
                            content,
                            ...default_callout
                        },
                        name,
                        branch,
                        nearby_distance
                    }
                })
                this.onSelectedMarker(0)
            })
        },
        onSelectedMarker (markerId) {
            this.markers_ = []
            this.markers.map((marker, i) => {
                const { name, longitude, latitude, branch } = marker
                const new_name = name.match(/.{1,16}/g).join('\n')
                const content = branch ? `${new_name}\n（${branch}）` : new_name
                if (markerId === i) {
                    marker.zIndex = 1
                    marker.callout = {
                        content,
                        ...selected_callout
                    }
                    this.moveDefaultCenter({
                        longitude,
                        latitude
                    })
                    this.selected = i
                    this.markers_.push(marker)
                }
            })
        },
        onClickMarker ({ markerId }) {
            this.onSelectedMarker(markerId)
        },
        onClickItem (i) {
            this.onSelectedMarker(i)
        },
        goNavigation (i) {
            const ctx = this.getMapCtx()
            const { longitude, latitude, name, branch } = this.markers[i]
            ctx.openMapApp({
                latitude,
                longitude,
                destination: branch ? `${name}（${branch}）` : name,
            })
        },
        goWeb() {
            const url = `/web_page?link=${encodeURIComponent(this.url)}&title=${process.env.APP_NAME}`
            wx.navigateTo({
                url
            })
        }
    }
}
